import * as React from 'react';

interface Props {
  ariaName?: string;
}

export const Lightning: React.FunctionComponent<Props> = ({ ariaName }) => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        d="M9.375 3.95026H5.625L6.89269 0L0.625 6.04974H4.375L3.10731 10L9.375 3.95026Z"
        fill="#FF8C00"
      />
    </svg>
  );
};
